/** Public /faq questions. Facts must match src/content/entity.ts and live plans. */
export interface FaqItem {
  q: string;
  a: string;
}

export const CORE_LINE =
  "LeadXkids – psychologist-designed, story-based behavioural and life-skills courses for children aged 8–14.";

export const FAQ_ITEMS: FaqItem[] = [
  {
    q: "Is there an online behavioural course for kids in India?",
    a: "Yes. LeadXkids offers 20 psychologist-designed, story-based behavioural and life-skills courses for children aged 8–14, made for Indian families. Children learn online at their own pace on a phone, tablet or computer.",
  },
  {
    q: "How can I help my child manage anger?",
    a: "Stay calm yourself, name the feeling (\"you look really angry\") and talk about it once your child has cooled down. Practise a simple routine together, such as stopping, taking slow breaths and then choosing what to say. Our course \"Calm Down Before You Explode\" walks children through these steps with stories and practice.",
  },
  {
    q: "How do I build confidence in a shy child?",
    a: "Give small, low-pressure chances to speak up, like ordering food or greeting a relative, and praise the effort rather than the result. Avoid labelling your child as \"shy\" in front of others. LeadXkids courses such as \"Speak Without Freezing\" and \"Make Friends with Confidence\" let children rehearse these moments safely first.",
  },
  {
    q: "What is social-emotional learning (SEL)?",
    a: "Social-emotional learning (SEL) is how children learn to understand their emotions, get along with others, make responsible choices and bounce back from setbacks. It complements academic learning rather than replacing it. LeadXkids teaches SEL skills through stories, choices and reflection.",
  },
  {
    q: "What age is LeadXkids for?",
    a: "LeadXkids is designed for children aged 8 to 14. Stories, examples and language are pitched for this age group, and parents get their own account to follow progress.",
  },
  {
    q: "Who designed the courses?",
    a: "The courses are psychologist-designed and built by the LeadXkids team, founded by Anvith Murthy in Bengaluru. Anvith is a former HR leader (CHRO at Rapido) with psychometric certification and a behavioural coaching background.",
  },
  {
    q: "How is it different from tuition or activity classes?",
    a: "Tuition focuses on school subjects and marks, and activity classes teach a hobby. LeadXkids focuses on everyday behaviour and life skills: confidence, emotions, friendships, focus and decision-making. It is self-paced, so there are no fixed class timings.",
  },
  {
    q: "How much does it cost?",
    a: "Quarterly membership is ₹1,499 for 3 months and Annual membership is ₹1,999 for a full year, both covering all 20 courses. Annual also includes the Know Your Child Assessment. Plans are one-time payments with no auto-renewal.",
  },
  {
    q: "Can schools use LeadXkids?",
    a: "LeadXkids is currently built for families at home. Schools interested in using it can write to hello@leadxkids.com to discuss options.",
  },
  {
    q: "How long does a course take?",
    a: "Each course is split into short 5–10 minute story-based units. Most children finish a course over 2–4 weeks with about 10 minutes a day, but they can go faster or slower.",
  },
  {
    q: "Does my child need a parent to sit with them?",
    a: "No. Children can use LeadXkids on their own once you have set up their profile. Parents can see progress and reflections from the parent account.",
  },
  {
    q: "Which devices does LeadXkids work on?",
    a: "It works in any modern browser on Android phones, iPhones, tablets and computers. You can also install it as an app from the browser for quicker access.",
  },
  {
    q: "Are there games, points or leaderboards?",
    a: "No. LeadXkids deliberately avoids points, streaks and leaderboards so children focus on the skill rather than on rewards. Progress is shown simply as course completion.",
  },
  {
    q: "Is there a free way to try it?",
    a: "Yes. Parents can take the free confidence check and use our free parent tools and Parent Library guides before buying a membership.",
  },
  {
    q: "What is the Know Your Child Assessment?",
    a: "It is a parent and child questionnaire that produces a parent-friendly report on your child's strengths and growth areas. It is included with Annual membership and is separate from the free confidence check.",
  },
];

export function faqPageJsonLd() {
  return {
    "@type": "FAQPage",
    "@id": "https://leadxkids.com/faq#faq",
    mainEntity: FAQ_ITEMS.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };
}
